<template>
  <div>
    <el-dialog
      :visible.sync="recordDialogVisible"
      title="产品基础属性查看"
      width="400px"
      @cancel="updateVal"
      @close="updateVal"
    >
      <div style="position:relative;">
          <el-image
          :src="dialogData.photoUrl ? dialogData.photoUrl : img_err"
          class="imgSize"
          fit="none"
        ></el-image>
        <el-button type="whiteBackground"  class="backPlay" @click="showDialog"  icon="el-icon-zoom-in" v-if="dialogData.photoUrl">查看原图</el-button>
      </div>
      <div>
        <el-table border :data="tableData" :show-header="false" height="15vw">
          <template v-for="item in columnData">
            <el-table-column
              :key="item.prop"
              :label="item.label"
              width="80px"
              :prop="item.prop"
              v-if="item.label === '类型'"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              align="center"
              v-else
            ></el-table-column>
          </template>
        </el-table>
      </div>
    </el-dialog>
    <pic-video
      v-model="picVideoVisible"
      :data="dialogData"
      :detailType="viewType"
      v-if="picVideoVisible"
    ></pic-video>
  </div>
</template>

<script>
  import img_err from '@/assets/images/img_err.png'
  import picVideoMxin from "../pic&video.mixin";

  export default {
  mixins: [picVideoMxin],
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: Boolean,
    dialogData: Object
  },
  computed: {
  },
  data() {
    return {
      recordDialogVisible: false,
      tableData: [],
      img_err
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.columnData = []
      this.recordDialogVisible = this.visible
      let col = []
      if( this.dialogData.amountHideFlag == 0)  {
        col = [  "产品名称",  "产品编码",  "风格",  "材质",  "系列",  "类别",  "空间",  "长",  "宽", "高", "规格",  "上市时间",  "颜色", "日常活动到手价", "最低成交金额",]
      }else {
        col = [  "产品名称",  "产品编码",  "风格",  "材质",  "系列",  "类别",  "空间",  "长",  "宽", "高",  "规格",  "上市时间",  "颜色", "日常活动到手价",]
      }
      let data = this.dialogData
      // 设置表头
      let columnData = [];
        // let obj = {
        //   label: item.storeName,
        //   prop: String(index),
        // };
        columnData.push({lable:'数据',prop: '0'});

      columnData.unshift({
        label: "类型",
        prop: "type",
      });
      this.$nextTick((_) => {
        this.columnData = columnData;
      });
      console.log(data);
      let table = [];
      for (let index = 0; index < col.length; index++) {
        let obj = {};
        obj["type"] = col[index];
          if (index == 0) {
            obj[String(0)] = data["productName"];
          } else if (index == 1) {
            obj[String(0)] = data["productCode"];
          } else if (index == 2) {
            obj[String(0)] = data["style"];
          } else if (index == 3) {
            obj[String(0)] = data["material"];
          } else if (index == 4) {
            obj[String(0)] = data["series"];
          } else if (index == 5) {
            obj[String(0)] = data["categoryName"];
          } else if (index == 6) {
            obj[String(0)] = data["space"];
          } else if (index == 7) {
            obj[String(0)] = data["sizeLength"];
          } else if (index == 8) {
            obj[String(0)] = data["sizeWidth"];
          } else if (index == 9) {
            obj[String(0)] = data["sizeHeight"];
          } else if (index == 10) {
            obj[String(0)] = data["specDesc"];
          } else if (index == 11) {
            obj[String(0)] = data["marketDate"];
          } else if (index == 12) {
            obj[String(0)] = data["color"];
          } else if (index == 13) {
            obj[String(0)] = data["productPrice"];
          } else if (index == 14) {
            obj[String(0)] = data["minSaleAmount"];
          }
        table.push(obj);
      }
      this.$nextTick(_=>{
        this.tableData = table;
        console.log(this.tableData);
      })
    },

    updateVal() {
      setTimeout(_=>{
        this.$emit('dialog', false)
      },200)
    },
  }
}
</script>

<style lang="stylus" scoped>
  .backPlay{
    &:hover{
      opacity: 1
    }
  }
  .el-button--whiteBackground {
      opacity: .7;
      font-size: 12px
      position: absolute;
      padding: 5px 7px
      right: 10px
      bottom: 10px
      color: #FFF;
      background-color: #0BB78E;
      border-color: #0BB78E;
  }

  .no-data
    display: flex;
    align-items: center
    justify-content: center
    color #999999
    padding 40px 0

  .imgSize {
    width: 100%;
    height: 280px
  }
</style>>

